import { Box, Container } from "@mui/material";
import React from "react";
import BusinessOutletTypes from "../../components/landing/BusinessOutletTypes";
import FeatureShowcase from "../../components/landing/FeatureShowcase";
import FeaturesSection from "../../components/landing/FeaturesSection";
import Hero from "../../components/landing/Hero";
import MetricsSection from "../../components/landing/MetricsSection";
import Testimonial from "../../components/landing/Testimonial";
import PublicLayout from "../../layouts/PublicLayout";
import DemoSection from "../../components/landing/DemoSection";

const demoOutlets = [
  {
    id: 1,
    title: "Fine dine",
    description: "Multiple order types, table maps",
    href: "/outlets/fine-dine",
  },
  {
    id: 2,
    title: "QSR",
    description: "Fast, minimal UI for quick orders",
    href: "/outlets/qsr",
  },
  {
    id: 3,
    title: "Cafe",
    description: "Order ahead, pickup & dine-in",
    href: "/outlets/cafe",
  },
];

export default function LandingPage() {
  return (
    <PublicLayout>
      <Container maxWidth="lg">
        <Hero />
        <Box>
          <FeaturesSection />
        </Box>
        <Box>
          <FeatureShowcase />
        </Box>
      </Container>

      <Box>
        <BusinessOutletTypes />
      </Box>

      <Container maxWidth="lg">
        <Testimonial />
        <MetricsSection />
      </Container>
      <DemoSection />
    </PublicLayout>
  );
}
